import { bl_del_job_custom_status_hdr_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DeliveryJobCustomStatusHdrContainer extends BaseContainerModel {
  bl_del_job_custom_status_hdr: bl_del_job_custom_status_hdr_RowClass = new bl_del_job_custom_status_hdr_RowClass();
}